module.exports = __webpack_public_path__ + "img/login_logo.c72fb361.png";